var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version-info-root"},[_vm._v("\n    Powered by Routematch © "+_vm._s(_vm.date.getFullYear())+" | Version "+_vm._s(_vm.packageVersion)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }